module.exports = __webpack_public_path__ + "media/images/send-d500ad97.png";